import type GetAllTradeHistoryDTO from '../../repositories/tradeHistory/dto/getAllTradeHistory.dto'
import type { TradeHistoryRepository } from '../../repositories/tradeHistory/tradeHistory.repository'

export default class TradeHistoryController {
  constructor(private repo: TradeHistoryRepository) {}

  async getAllTradeHistory(dto: GetAllTradeHistoryDTO) {
    return await this.repo.getAll(dto)
  }
}
